document.addEventListener("DOMContentLoaded", () => {
  const datesWrapper = document.querySelector('.swiper-dates');
  const leftArrow = document.querySelector('.arrow-left');
  const rightArrow = document.querySelector('.arrow-right');

  if (!datesWrapper || !leftArrow || !rightArrow) return;

  // Function to toggle arrow visibility based on overflow
  const toggleArrowVisibility = () => {
    const datesBounds = datesWrapper.getBoundingClientRect();
    const firstButton = datesWrapper.firstElementChild;
    const lastButton = datesWrapper.lastElementChild;

    if (!firstButton || !lastButton) return;

    const firstButtonBounds = firstButton.getBoundingClientRect();
    const lastButtonBounds = lastButton.getBoundingClientRect();

    // Check for overflow on the left and right
    const isLeftOverflowing = firstButtonBounds.left < datesBounds.left;
    const isRightOverflowing = lastButtonBounds.right > datesBounds.right;

    // Show or hide arrows based on overflow
    leftArrow.style.display = isLeftOverflowing ? 'block' : 'none';
    rightArrow.style.display = isRightOverflowing ? 'block' : 'none';
  };

  // Function to scroll the dates container
  const scrollDates = (direction) => {
    const scrollAmount = 100; // Adjust this scroll amount if needed
    datesWrapper.scrollBy({
      left: direction * scrollAmount,
      behavior: 'smooth',
    });
  };

  // Add click event listeners for arrows
  leftArrow.addEventListener('click', () => {
    scrollDates(-1);
  });

  rightArrow.addEventListener('click', () => {
    scrollDates(1);
  });

  // Add event listeners for dynamic adjustments
  datesWrapper.addEventListener('scroll', toggleArrowVisibility);
  window.addEventListener('resize', toggleArrowVisibility);

  // Initial visibility check
  toggleArrowVisibility();
});
